// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import { WorkbookVariantShortFragmentFragmentDoc } from "../../Workbook/gql/Fragment.short.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateWorkbookVariantMutationVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  workbookId: Types.Scalars["ID"]["input"];
  name?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  description?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  baselineVariantId: Types.Scalars["ID"]["input"];
  queryText: Types.Scalars["String"]["input"];
  plannerSettings: Types.Scalars["JSON"]["input"];
  appliedInsights?: Types.InputMaybe<Types.Scalars["JSON"]["input"]>;
  introducedParameters?: Types.InputMaybe<
    | Array<Types.WorkbookIntroducedParameterInput>
    | Types.WorkbookIntroducedParameterInput
  >;
}>;

export type CreateWorkbookVariantMutation = {
  __typename?: "Mutation";
  createWorkbookVariant: {
    __typename?: "WorkbookVariant";
    id: string;
    createdAt: number;
    updatedAt: number;
    description?: string | null;
    queryFingerprint: string;
    queryText: string;
    name: string;
    queryTextWithAlias: string;
    paramRefAliasMap: any;
    draft: boolean;
    plannerSettings: any;
    appliedInsights?: any | null;
    user?: { __typename?: "User"; id: string; fullname?: string | null } | null;
    queryTextWithParameters: Array<{
      __typename?: "QueryTextWithParameters";
      id: string;
      parameterSetId: string;
      queryWithParameters: string;
    }>;
  };
};

export const CreateWorkbookVariantDocument = gql`
  mutation CreateWorkbookVariant(
    $databaseId: ID!
    $workbookId: ID!
    $name: String
    $description: String
    $baselineVariantId: ID!
    $queryText: String!
    $plannerSettings: JSON!
    $appliedInsights: JSON
    $introducedParameters: [WorkbookIntroducedParameterInput!]
  ) {
    createWorkbookVariant(
      databaseId: $databaseId
      workbookId: $workbookId
      name: $name
      description: $description
      baselineVariantId: $baselineVariantId
      queryText: $queryText
      plannerSettings: $plannerSettings
      appliedInsights: $appliedInsights
      introducedParameters: $introducedParameters
    ) {
      ...WorkbookVariantShortFragment
    }
  }
  ${WorkbookVariantShortFragmentFragmentDoc}
`;
export type CreateWorkbookVariantMutationFn = Apollo.MutationFunction<
  CreateWorkbookVariantMutation,
  CreateWorkbookVariantMutationVariables
>;

/**
 * __useCreateWorkbookVariantMutation__
 *
 * To run a mutation, you first call `useCreateWorkbookVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkbookVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkbookVariantMutation, { data, loading, error }] = useCreateWorkbookVariantMutation({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      workbookId: // value for 'workbookId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      baselineVariantId: // value for 'baselineVariantId'
 *      queryText: // value for 'queryText'
 *      plannerSettings: // value for 'plannerSettings'
 *      appliedInsights: // value for 'appliedInsights'
 *      introducedParameters: // value for 'introducedParameters'
 *   },
 * });
 */
export function useCreateWorkbookVariantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkbookVariantMutation,
    CreateWorkbookVariantMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWorkbookVariantMutation,
    CreateWorkbookVariantMutationVariables
  >(CreateWorkbookVariantDocument, options);
}
export type CreateWorkbookVariantMutationHookResult = ReturnType<
  typeof useCreateWorkbookVariantMutation
>;
export type CreateWorkbookVariantMutationResult =
  Apollo.MutationResult<CreateWorkbookVariantMutation>;
export type CreateWorkbookVariantMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkbookVariantMutation,
  CreateWorkbookVariantMutationVariables
>;
